module.exports = __webpack_public_path__ + "img/sw-bc01.83186508.jpg";